export const profile = {
  title: "Perfil",
  info: {
    title: "Informações do Usuário",
    email: "Email",
    firstName: "Nome",
    lastName: "Sobrenome",
    cpf: "CPF",
    update: "Atualizar Perfil",
    birthday: "Data de Nascimento",
  },
  password: {
    title: "Alterar Senha",
    currentPassword: "Senha Atual",
    newPassword: "Nova Senha",
    confirmPassword: "Confirmar Senha",
    update: "Atualizar Senha",
    success: "Senha atualizada com sucesso",
    error: "Falha ao atualizar senha",
    mismatch: "As novas senhas não coincidem",
    tooShort: "A senha deve ter pelo menos 8 caracteres",
    // setTitle: "Atualização de Senha",
  },
  update: {
    success: "Perfil atualizado com sucesso",
    error: "Falha ao atualizar perfil",
  },
  affiliate: {
    title: "Programa de Afiliados",
    cardDescription:
      "Nosso programa de afiliados é simples, para cada pagamento feito por uma indicação sua, você receberá uma commissão em créditos de acordo com seu nível.",
    cardDescription2:
      "O sistema de afiliados está sujeito a reajustes e alterações, conforme nossas políticas de afiliados.",
    tiers: {
      level: "Nível",
      requirement: "Requisito",
      commission: "Taxa de Comissão",
      standard: "Padrão",
      standardReq: "Até $100 em indicações totais",
      silver: "Prata",
      silverReq: "$100 a $500 em indicações totais",
      gold: "Ouro",
      goldReq: "Acima de $500 em indicações totais",
    },
    yourId: "Seu ID de Afiliado:",
    copy: "Copiar ID",
    copied: "Copiado para a área de transferência!",
    link: "Seu Link de Afiliado:",
    copyLink: "Copiar Link",
    linkCopied: "Link copiado para a área de transferência!",
    join: "Tornar-se um Afiliado",
    success: "Você agora é um afiliado!",
    error: "Failed to become an affiliate",
    earnings: {
      title: "Seus Ganhos",
      total: "Ganhos Totais",
      pending: "Ganhos Pendentes",
      referrals: "Total de Indicações",
      recentEarnings: "Ganhos Recentes",
      noEarnings: "Nenhum ganho ainda",
      source: "Fonte",
      amount: "Valor",
      status: "Status",
      date: "Data",
    },
  },
};
